/* eslint-disable @typescript-eslint/naming-convention */
'use strict';

export const LocaleHelper = Object.freeze({
  dateToStringFormat: {
    sr: 'sr-Latn-RS',
    en: 'en-GB',
    ng: 'en-NG',
    hr: 'hr-HR',
    me: 'sr-Latn-ME',
    ba: 'sr-Latn-BA',
    'sr-Latn': 'sr-Latn',
    'en-US': 'en-US',
    'en-NG': 'en-NG',
    'hr-HR': 'hr-HR',
    'sr-Latn-ME': 'sr-Latn-ME',
    'sr-Latn-BA': 'sr-Latn-BA',
  },
  cultureName: {
    sr: 'sr-Latn',
    en: 'en-US',
    hr: 'hr-HR',
    me: 'sr-Latn-ME',
    ba: 'sr-Latn-BA',
    ng: 'en-NG',
    'en-NG': 'en-NG',
    'sr-Latn': 'sr-Latn',
    'en-US': 'en-US',
    'hr-HR': 'hr-HR',
    'sr-Latn-ME': 'sr-Latn-ME',
    'sr-Latn-BA': 'sr-Latn-BA',

  },
  languageForBetradar: {
    sr: 'srl',
    en: 'en_us',
    hr: 'hr',
    me: 'me',
    ba: 'srl',
    ng: 'en',
    'en-NG': 'en',
    'sr-Latn': 'srl',
    'en-US': 'en',
    'hr-HR': 'hr',
    'sr-Latn-ME': 'me',
    'sr-Latn-BA': 'srl',
  }

});
